import Splide from '@splidejs/splide';
import { minMediaQueryXL } from 'PlugAndPlay/_global/js/screenSize';

export default function _carousel() {
    /**
     * carousel wrapper selector
     * carousel wrapper selector
     * @const {string}
     */
    const CAROUSEL_SELECTOR = '[data-component="splide"]';

    /**
     * carousel slides selector
     * carousel slides selector
     * @const {string}
     */
    const STANDARD_SLIDE_SELECTOR = '[data-component="splide__slide-standard"]';

    /**
     * carousel slides selector
     * @const {string}
     */
    const FEATURE_SLIDE_SELECTOR = '[data-component="splide__slide-feature"]';

    /**
     * carousel slides selector
     * @const {string}
     */
    const sideNavPageClass = '.page-layout--content-with-nav';

    const sideNavPage = document.querySelector(sideNavPageClass);

    /**
     * carousel slides selector
     * @const {string}
     */
    const narrowPageClass = '.page-layout--narrow';

    const narrowPage = document.querySelector(narrowPageClass);

    // hide buttons when carousel contains 4 or less standard slides
    // and when carousel contains 1 feature and 2 standard slides
    const hideNavButtons = (carousel) => {
        const standardSlides = carousel.querySelectorAll(
            STANDARD_SLIDE_SELECTOR
        ).length;
        const featureSlide = carousel.querySelectorAll(
            FEATURE_SLIDE_SELECTOR
        ).length;
        const navButtons = Array.from(
            carousel.getElementsByClassName('splide__arrow')
        );

        if (
            (featureSlide > 0 && standardSlides <= 2) ||
            (featureSlide === 0 && standardSlides <= 4)
        ) {
            navButtons.forEach((button) => {
                // eslint-disable-next-line no-param-reassign
                button.style.display = 'none';
            });
        }
        if (
            (!!sideNavPage === true &&
                featureSlide > 0 &&
                standardSlides > 1) ||
            (!!sideNavPage === true && featureSlide === 0 && standardSlides > 3)
        ) {
            navButtons.forEach((button) => {
                // eslint-disable-next-line no-param-reassign
                button.style.display = 'flex';
            });
        }
    };

    // all carousel instances
    const allCarousels = document.querySelectorAll(CAROUSEL_SELECTOR);

    // desktop media breakpoint number extracted
    const screenXL = Number(minMediaQueryXL.replace(/\D/g, ''));

    // fire up splide library
    const initialiseCarousel = () => {
        allCarousels.forEach((carousel) => {
            hideNavButtons(carousel);
            // carousel.setAttribute('data-slide-count', ca)
            // Get number of slides
            const carouselSlides = carousel.querySelectorAll(
                '.splide__list > li:not(.splide__slide--clone'
            );

            let slideType = 'loop';

            if (carouselSlides.length <= 4) {
                slideType = 'slide';
            }
            if (!!sideNavPage === true && carouselSlides.length >= 4) {
                slideType = 'loop';
            }
            if (!!narrowPage === true && carouselSlides.length >= 4) {
                slideType = 'loop';
            }

            let perPageNumber = 4;

            if (!!sideNavPage === true || !!narrowPage === true) {
                perPageNumber = 3;
            }

            const splide = new Splide(carousel, {
                type: slideType,
                autoWidth: true,
                pagination: false,
                speed: 650,
                dragMinThreshold: 10,
                mediaQuery: 'min',
                breakpoints: {
                    [screenXL]: {
                        drag: false,
                        perPage: perPageNumber,
                    },
                },
            });

            splide.mount();
        });
    };

    /**
     * @const {boolean}
     */
    const carouselExists = !!document.querySelector(CAROUSEL_SELECTOR);

    // If the module exists, do whatever we need to
    if (carouselExists) {
        initialiseCarousel();
    }
}

// calls the carousel function
_carousel();
